// eslint-disable-next-line import/no-unresolved
import { Layout, PlotData } from 'plotly.js-basic-dist';
import { getY2TraceConfig, getYTraceConfig, plotLayoutConfig } from '../RiskProductsWidget.presentational.constants';

const traceCRE: Partial<PlotData> = getYTraceConfig('CRE');
const traceCRL: Partial<PlotData> = getY2TraceConfig('CRL', false);

export const plotDefaultData: Partial<PlotData>[] = [traceCRE, traceCRL];

export const plotDefaultLayout: Partial<Layout> = {
  ...plotLayoutConfig,
  margin: {
    t: 0,
    r: 12,
    b: 30,
    l: 46,
    pad: 4,
  },
  yaxis: {
    ...plotLayoutConfig.yaxis,
    type: 'log',
  },
  yaxis2: {
    ...plotLayoutConfig.yaxis2,
    type: 'log',
  },
};

export const infoTooltipText =
  'The Credit Risk Estimate (CRE), is a one-year probability of default. The Credit Risk Level (CRL) indicates a company’s short-term default risk relative to its peers and historical averages.';
